import script from "./HomePortfolio.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePortfolio.vue?vue&type=script&setup=true&lang=js"

import "./HomePortfolio.vue?vue&type=style&index=0&id=0f6b1c08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6b1c08"]])

export default __exports__